const debounce = {
  inserted: (el, binding) => {
    if (typeof binding.value !== 'function') {
      // eslint-disable-next-line no-throw-literal
      throw 'debounce的回调必须是方法'
    }
    let timer
    el.addEventListener('click', () => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(_ => {
        binding.value()
      }, 1000)
    })
  }
}

export default debounce
